import { SESSION_ID, USER_ID } from "@/constants/common";
import Cookies from "js-cookie";

export const generateId = () =>
  (
    Math.random().toString(36).substring(4) +
    Math.random().toString(36).substring(4)
  ).slice(0, 16);

const STORE_USER_ID_PREFIX = "widget-";

export const generateUserId = () => {
  return `${STORE_USER_ID_PREFIX}${generateId()}`;
};

export const getUserId = () => {
  const storedId = Cookies.get(USER_ID);

  if (storedId?.startsWith(STORE_USER_ID_PREFIX)) return storedId;

  const generatedId = generateUserId();

  Cookies.set(USER_ID, generatedId, {
    expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
  });

  return generatedId;
};

export const getSessionId = (expires?: number) => {
  const storedId = Cookies.get(SESSION_ID);

  if (storedId) return storedId;

  const generatedId = generateId();

  Cookies.set(SESSION_ID, generatedId, {
    expires,
  });

  return generatedId;
};

export const updateSessionId = (expires?: number | Date) => {
  const sessionId = getSessionId();
  Cookies.set(SESSION_ID, sessionId, {
    expires,
  });
  return sessionId;
};
